module.exports = __webpack_public_path__ + "img/tpc-17.87cd4441.webp";